
export const BASE_URL = 'https://tour-management-app-ucb4.onrender.com/api/v1';